import {
  AdminHeader,
  AdminSpinner,
  BTMenuResponse,
  BrandImageComponent,
  BrandTemplateEntity,
  Div,
  HeaderIconWrapper,
  ImportMenuIcon,
  Tab,
  TabsWrapper,
  getBrandTemplateMenu,
  grantNotificationPermission,
  reportError,
} from '@vgrubs/components';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Categories } from './MenuProviderSections/Categories/Categories';
import { Items } from './MenuProviderSections/Items/Items';
import { Modifiers } from './MenuProviderSections/Modifiers/Modifiers';

import { isAdmin } from '../../helpers';
import { ImportMenuModal } from './components/ImportMenuModal';
import { MenuImportPreview } from './MenuImportPreview';

export const BrandTemplateMenu = () => {
  const [importMenuModal, setImportMenuModal] = useState(false);
  const [menu, setMenu] = useState<BTMenuResponse | null>(null);
  const [template, setTemplate] = useState<BrandTemplateEntity | null>(null);
  // const [simpleMenu, setSimpleMenu] = useState<MenuEntity[] | null>(null);
  const [loading, setLoading] = useState(false);
  const { locationId, brandId } = useParams() as {
    locationId: string;
    brandId: string;
  };

  const [providerToImport, setProviderToImport] = useState<string | null>(null);
  const [urlToScrape, setUrlToScrape] = useState<string | null>(null);

  const [menuTab, setMenuTab] = useState(1);
  const [isNotConnected, setIsNotConnected] = useState<string | null>(null);

  const { brandTemplateId } = useParams() as {
    brandTemplateId: string;
  };

  async function handleGetMenu() {
    setMenu(null);
    try {
      setLoading(true);
      const { data } = await getBrandTemplateMenu(brandTemplateId);
      setMenu(data.data.menu);
      setTemplate(data.data.template);
    } catch (error) {
      reportError(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    // getStoreName();
    grantNotificationPermission();
    setIsNotConnected(null);
    handleGetMenu();
  }, []);

  // const [storeName, setStoreName] = useState<MenuNamesResponse | null>(null);

  // async function getStoreName() {
  //   try {
  //     const { data } = await getLocationStoreName(locationId, brandId);

  //     setStoreName(data.data);
  //   } catch (error) {
  //     reportError(error);
  //   }
  // }

  // // --- keep global fields via store (not scoped) ---
  // const { initializedProviderConnection, setInitializedProviderConnection } =
  //   useProviderSyncStatus();

  // // --- scoped statuses for (locationId, brandId) + scoped setter wrapper ---
  // const statuses = useProviderSyncStatus(
  //   (st) =>
  //     st.statusesByScope?.find(
  //       (e) =>
  //         e.locationId === Number(locationId) && e.brandId === Number(brandId)
  //     )?.statuses ?? []
  // );

  // const setStatuses = (
  //   value: import('components/src/types/api/location.types').ProviderAndProviderStatusResponse
  // ) =>
  //   useProviderSyncStatus
  //     .getState()
  //     .setStatusesFor(
  //       { locationId: Number(locationId), brandId: Number(brandId) },
  //       value
  //     );

  // const store = storeName ? renderStoreName(storeName) : '';

  // const handlePublish = async () => {
  //   try {
  //     setSyncLoading(true);
  //     const { data } = await publishMenu(locationId, brandId);
  //     setSyncStatus(data.data);

  //     if (initializedProviderConnection) {
  //       setStatuses(
  //         statuses.map((item) => {
  //           if (item.provider === initializedProviderConnection) {
  //             return { ...item, haveMenuSet: true };
  //           }
  //           return item;
  //         })
  //       );
  //     }

  //     setInitializedProviderConnection(null);
  //   } catch (error) {
  //     reportError(error);
  //   } finally {
  //     setSyncLoading(false);
  //   }
  // };

  // const handleChangeShouldPublish = (shouldPublish: boolean) => {
  //   setSyncStatus((prev) => {
  //     if (!prev) return null;
  //     return {
  //       ...prev,
  //       shouldPublish,
  //     };
  //   });
  // };

  // const lastPublishedAtText = `Last Published At:  ${
  //   syncStatus?.lastPublishedAt
  //     ? dateFormat(syncStatus.lastPublishedAt)
  //     : 'Never'
  // }`;

  // const PublishButton = () => {
  //   return (
  //     <TooltipWrapper $width="100%" tooltip={lastPublishedAtText}>
  //       <Button
  //         disabled={!syncStatus?.shouldPublish}
  //         $selected
  //         onClick={handlePublish}
  //         $loading={syncLoading}
  //         $wSM="100%"
  //       >
  //         {syncStatus?.shouldPublish ? 'Publish' : 'Published'}
  //       </Button>
  //     </TooltipWrapper>
  //   );
  // };

  const storeName = template?.name || '';

  return (
    <div>
      {loading && <AdminSpinner />}
      <AdminHeader title="Menu" subtitle={storeName}>
        <Div $flex $alignCenter $gap="16px" $gapSM="8px">
          {isAdmin && (
            <HeaderIconWrapper onClick={() => setImportMenuModal(true)}>
              <ImportMenuIcon />
            </HeaderIconWrapper>
          )}
        </Div>
      </AdminHeader>

      <Div
        $mobile
        $fixed
        $bottom="30px"
        $left="30px"
        $right="30px"
        $width="calc(100% - 60px)"
      ></Div>

      <Div $p="0 0 100px 0">
        <>
          <Div $flex $between $alignCenter $pSM="0">
            <TabsWrapper>
              <Tab selected={menuTab === 1} onClick={() => setMenuTab(1)}>
                Items
              </Tab>
              <Tab selected={menuTab === 2} onClick={() => setMenuTab(2)}>
                Modifiers
              </Tab>
              <Tab selected={menuTab === 3} onClick={() => setMenuTab(3)}>
                Categories
              </Tab>
            </TabsWrapper>
            <Div $desktop $p="20px 0px">
              <BrandImageComponent
                height={80}
                width={80}
                image={template?.imageUrl}
              />
            </Div>
          </Div>

          {!isNotConnected && (
            <>
              {menuTab === 1 && (
                <Items menu={menu} setMenu={setMenu} setLoading={setLoading} />
              )}
              {menuTab === 2 && (
                <Modifiers
                  menu={menu}
                  setMenu={setMenu}
                  setLoading={setLoading}
                />
              )}
              {menuTab === 3 && (
                <Categories
                  menu={menu}
                  setMenu={setMenu}
                  setLoading={setLoading}
                />
              )}
            </>
          )}
        </>
      </Div>

      {isAdmin && (
        <ImportMenuModal
          importMenuModal={importMenuModal}
          closeModal={() => {
            setImportMenuModal(false);
          }}
          setProviderToImport={setProviderToImport}
          setUrlToScrape={setUrlToScrape}
        />
      )}

      {isAdmin && (
        <MenuImportPreview
          scrappingUrl={urlToScrape}
          setScrappingUrl={setUrlToScrape}
          importProvider={providerToImport}
          storeName={storeName}
          handleGetMenu={handleGetMenu}
          closeModal={() => {
            setProviderToImport(null);
          }}
          setMenuMain={setMenu}
        />
      )}
    </div>
  );
};
